import request from '@/utils/request'

// 查询官网banner列表
export function listExample(query) {
  return request({
    url: '/api/example/list',
    method: 'get',
    params: query
  })
}

// 查询官网banner详细
export function getExample(exampleId) {
  return request({
    url: '/api/example/' + exampleId,
    method: 'get'
  })
}